import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export function getAmazonSellerAccounts(): Promise<any> {
  return fetchWrapper(endpoint + `/v1/amazon-seller-account`, {
    method: 'get',
  }).then((res) => res.json());
}

export function createAmazonSellerAccount(nickname: string): Promise<any> {
  return fetchWrapper(endpoint + `/v1/amazon-seller-account`, {
    method: 'post',
    body: JSON.stringify({ nickname }),
  });
}

export function updateAmazonSellerAccount(
  id: string,
  sellerId: string,
  authCode: string,
): Promise<any> {
  return fetchWrapper(endpoint + `/v1/amazon-seller-account/${id}`, {
    method: 'put',
    body: JSON.stringify({ sellerId, authCode }),
  });
}
